/**
 * Wrapper zodResolver compatible Zod 4
 *
 * @hookform/resolvers@4 detecte ZodError via `Array.isArray(error.errors)`,
 * mais Zod 4 a renomme `.errors` en `.issues`.
 * Ce wrapper parse manuellement avec le schema et mappe les erreurs.
 */
import type { FieldValues, FieldErrors } from 'react-hook-form';
import { toNestErrors } from '@hookform/resolvers';
import type { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function zodResolver(schema: z.ZodSchema<any, any, any>) {
  return async (values: FieldValues, _context: any, options: any) => {
    const result = await schema.safeParseAsync(values);

    if (result.success) {
      return { values: result.data, errors: {} as FieldErrors };
    }

    const fieldErrors: Record<string, { message: string; type: string }> = {};
    for (const issue of result.error.issues) {
      const path = issue.path.join('.');
      if (!fieldErrors[path]) {
        fieldErrors[path] = { message: issue.message, type: issue.code };
      }
    }

    return {
      values: {},
      errors: toNestErrors(fieldErrors, options),
    };
  };
}
